import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { isNil } from 'lodash-es';

export function inputSelectGroupRequiredValidator(
  formControl: AbstractControl
): ValidationErrors | null {
  const isRequired = formControl.hasValidator(Validators.required);
  const formValue = formControl.value;

  if (isNil(formValue)) {
    return isRequired ? { required: true } : null;
  }

  const hasValue = !isNil(formValue.value) && formValue.value !== '';
  const hasOption = !isNil(formValue.option) && formValue.option !== '';

  if (isRequired) {
    if (hasValue && hasOption) {
      return null;
    }
  } else {
    if (!hasValue || (hasValue && hasOption)) {
      return null;
    }
  }

  return { required: true };
}
